const rootElement = document.getElementById('root');

export default function Popover(theme) {
  return {
    MuiPopover: {
      defaultProps: {
        container: rootElement,
      },
      variants: [
        {
          props: { variant: 'filter' },
          style: {
            '.MuiPopover-paper': {
              padding: 30,
              borderRadius: 20,
            },
          },
        },
      ],
    },
  };
}
